import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const RECENT_BUYERS = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Juan',
  city: 'Córdoba'
}, {
  name: 'Sofía',
  city: 'Rosario'
}, {
  name: 'Lucas',
  city: 'Mendoza'
}, {
  name: 'Valentina',
  city: 'La Plata'
}, {
  name: 'Martín',
  city: 'Mar del Plata'
}, {
  name: 'Camila',
  city: 'Salta'
}, {
  name: 'Diego',
  city: 'Tucumán'
}, {
  name: 'Florencia',
  city: 'Santa Fe'
}, {
  name: 'Pablo',
  city: 'Neuquén'
}, {
  name: 'Carolina',
  city: 'Bahía Blanca'
}, {
  name: 'Andrés',
  city: 'San Juan'
}, {
  name: 'Luciana',
  city: 'Corrientes'
}, {
  name: 'Federico',
  city: 'Resistencia'
}, {
  name: 'Agustina',
  city: 'Posadas'
}];
const TIME_AGO = ['hace unos segundos', 'hace 1 minuto', 'hace 2 minutos', 'hace 3 minutos', 'hace 5 minutos'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState(RECENT_BUYERS[0]);
  const [timeAgo, setTimeAgo] = useState(TIME_AGO[0]);
  useEffect(() => {
    const showNewBuyer = () => {
      const randomBuyer = RECENT_BUYERS[Math.floor(Math.random() * RECENT_BUYERS.length)];
      const randomTime = TIME_AGO[Math.floor(Math.random() * TIME_AGO.length)];
      setBuyer(randomBuyer);
      setTimeAgo(randomTime);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay of 5 seconds
    const initialTimeout = setTimeout(showNewBuyer, 5000);
    // Show every 10-15 seconds (random interval)
    const interval = setInterval(() => {
      showNewBuyer();
    }, 10000 + Math.random() * 5000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-in-bottom" data-id="element-202">
      <div className="relative flex items-center gap-4 rounded-xl bg-white p-4 shadow-2xl border border-gray-200 max-w-sm" data-id="element-203">
        <button onClick={() => setIsVisible(false)} className="absolute -top-2 -right-2 rounded-full bg-gray-100 p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-colors shadow-md" data-id="element-204">
          <X size={12} data-id="element-205" />
        </button>

        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-green-100" data-id="element-206">
          <CheckCircle2 className="h-6 w-6 text-green-600" data-id="element-207" />
        </div>

        <div data-id="element-208">
          <p className="text-sm font-medium text-gray-900" data-id="element-209">
            <span className="font-bold" data-id="element-210">{buyer.name}</span> de{' '}
            <span className="font-semibold" data-id="element-211">{buyer.city}</span>
          </p>
          <p className="text-sm text-gray-600" data-id="element-212">
            compró el <span className="font-bold text-blue-600" data-id="element-213">MEGA KIT</span>
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-214">{timeAgo}</p>
        </div>
      </div>
    </div>;
}